// The interstitial after a guest signs in: posts the stored notes to
// /guest/transfer, clears the browser only once the server has answered
// 200 (keeping any note it reported as failed), then moves on to the event
// or, with nothing to move, the library.
import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { getGuestNotes, clearGuestData } from "../guest/storage"

export default class extends Controller {
  static targets = ["count", "word", "error", "fallback"]
  static values = {
    url: String,
    libraryUrl: String,
    eventUrlTemplate: String
  }

  connect() {
    const notes = getGuestNotes()
    if (notes.length === 0) {
      clearGuestData()
      Turbo.visit(this.libraryUrlValue)
      return
    }
    this.countTarget.textContent = String(notes.length)
    this.wordTarget.textContent = notes.length === 1 ? "note" : "notes"
    this.transfer(notes)
  }

  async transfer(notes) {
    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content || ""
        },
        credentials: "same-origin",
        body: JSON.stringify({ notes })
      })
      if (!response.ok) throw new Error(`The server answered ${response.status}.`)
      const result = await response.json()
      clearGuestData()
      const eventId = result.eventId
      Turbo.visit(eventId ? this.eventUrlTemplateValue.replace("EVENT_ID", encodeURIComponent(eventId)) : this.libraryUrlValue)
    } catch (error) {
      this.errorTarget.textContent = `Couldn't save your notes: ${error.message} They're still on this device — try again from your library.`
      this.errorTarget.hidden = false
      this.fallbackTarget.hidden = false
    }
  }
}
